
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"1.75 2.58 16.5 15.17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.5 8.826l7.5 4.09 7.5 4.091M17.5 8.826l-7.5 4.09 7.5-4.09z","fill":"#475668"}}),_c('path',{attrs:{"d":"M2.5 8.826l2.727-1.978L10 3.334l4.773 3.514L17.5 8.826m-15 0v8.181h15m-15-8.181l7.5 4.09m7.5 4.091V8.827m0 8.181l-7.5-4.09m7.5-4.091l-7.5 4.09","stroke":"#475668","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    